import React from "react";

interface Props {
  color?: string;
  size?: number;
}

const TicketNameIcon: React.FC<Props> = ({ color = "#79808A", size = 20 }) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.625 7.8125C15.9874 7.81293 16.3364 7.93935 16.6143 8.16699L16.7295 8.27051C17.0224 8.56343 17.187 8.96076 17.1875 9.375V14.6875H13.75L13.5957 14.6797C13.2893 14.649 12.9989 14.5281 12.7607 14.333L12.6455 14.2295C12.3526 13.9366 12.188 13.5392 12.1875 13.125V12.5L12.1953 12.3457C12.226 12.0393 12.3469 11.7489 12.542 11.5107L12.6455 11.3955C12.9018 11.1392 13.2381 10.9812 13.5957 10.9453L13.75 10.9375H16.5625V9.375C16.5625 9.15763 16.4871 8.948 16.3506 8.78125L16.2881 8.71191C16.1123 8.5361 15.8736 8.4375 15.625 8.4375H12.8125V7.8125H15.625ZM7.27832 4.6875L10.8076 14.6875H10.2246L9.23828 11.7744L9.16602 11.5625H4.58496L4.5127 11.7744L3.52637 14.6875H2.94238L6.47168 4.6875H7.27832ZM13.75 11.5625C13.5014 11.5625 13.2627 11.6611 13.0869 11.8369C12.9111 12.0127 12.8125 12.2514 12.8125 12.5V13.125C12.8125 13.3736 12.9111 13.6123 13.0869 13.7881C13.2627 13.9639 13.5014 14.0625 13.75 14.0625H16.5625V11.5625H13.75ZM6.49609 5.91797L4.93555 10.5244L4.7959 10.9375H8.9541L8.81445 10.5244L7.25488 5.91797L7.18262 5.70605H6.56836L6.49609 5.91797Z"
          fill={color}
          stroke={color}
          stroke-width="0.625"
        />
      </svg>
    </>
  );
};

export default TicketNameIcon;
